// extracted by mini-css-extract-plugin
export default {"overlay":"NoticeModal_overlay__RAY7g"};